<template>
  <transition name="fade">
    <teleport to="body" :disabled="!isMounted">
      <div v-if="showOverlay" class="global-modal-overlay"></div>
    </teleport>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'GlobalOverlay',
  data() {
    return {
      isMounted: false
    };
  },
  computed: {
    ...mapState(['showOverlay'])
  },
  mounted() {
    this.isMounted = true;
  },
  beforeUnmount() {
    this.$store.commit('setOverlay', false);
  },
  methods: {
    ...mapMutations(['setOverlay'])
  }
}
</script>

<style scoped>
.global-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: $zindex-global-overlay;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style> 